import { axios } from '@/utils/request'

export function getUserNamelist(parameter = {}) {
  return axios({
    url: '/collectionTelMarket/queryUserNameList',
    method: 'post',
    data: parameter
  })
}

export function queryTelMarketStatisticsList(parameter = {}) {
  return axios({
    url: '/collectionTelMarket/telMarketResultStatistics',
    method: 'post',
    data: parameter
  })
}

export function updateStatusByUserId(parameter = {}) {
  return axios({
    url: '/collectionTelMarket/updateTaskStatusByUserId',
    method: 'post',
    data: parameter
  })
}

export function queryTelMarketList(parameter = {}) {
  return axios({
    url: '/collectionTelMarket/queryTelInfos',
    method: 'post',
    data: parameter
  })
}

export function getAllCollectionTask (parameter = {}) {
  return axios({
    url: '/collectionTask/allTask',
    method: 'post',
    data: parameter
  })
}

export function getCollectionUser (parameter = {}) {
  return axios({
    url: '/collectionTask/listCollectionUser',
    method: 'post',
    data: parameter
  })
}

export function getCollectionUserSchedule (parameter = {}) {
  return axios({
    url: '/collectionUserSchedule/list',
    method: 'post',
    data: parameter
  })
}

export function getCollectionManualUserSchedule (parameter = {}) {
  return axios({
    url: '/collectionUserSchedule/listByConfigId',
    method: 'post',
    data: parameter
  })
}

export function getUnSettledCount (parameter = {}) {
  return axios({
    url: '/collectionUserSchedule/queryUnSettledCount',
    method: 'post',
    data: parameter
  })
}

export function submitLoanCountList (parameter = {}) {
  return axios({
    url: '/collectionUserSchedule/submitManualSchedule',
    method: 'post',
    data: parameter
  })
}

export function insertOrUpdateCollectionScheduling (parameter = {}) {
  return axios({
    url: '/collectionUserSchedule/insertOrUpdate',
    method: 'post',
    data: parameter
  })
}

export function modCollectionTaskUser (parameter = {}) {
  return axios({
    url: '/collectionTask/changeUser',
    method: 'post',
    data: parameter
  })
}

export function getMyCollectionTask (parameter = {}) {
  return axios({
    url: '/collectionTask/myTask',
    method: 'post',
    data: parameter
  })
}

export function getHistoryCollectionTask (parameter = {}) {
  return axios({
    url: '/collectionTask/historyTask',
    method: 'post',
    data: parameter
  })
}

export function getCollectionPerformance (parameter = {}) {
  return axios({
    url: '/collectionTask/performance',
    method: 'post',
    data: parameter
  })
}

export function followCollection (parameter = {}) {
  return axios({
    url: '/collectionTask/follow',
    method: 'post',
    data: parameter
  })
}
export function getListUserWithNum (parameter = {}) {
  return axios({
    url: '/collectionTask/listUserWithNum',
    method: 'post',
    data: parameter
  })
}
export function batchChangeUser (parameter = {}) {
  return axios({
    url: '/collectionTask/changeUsers',
    method: 'post',
    data: parameter
  })
}
export function queryBackPerformance (parameter = {}) {
  return axios({
    url: '/collectionTask/backPerformance',
    method: 'post',
    data: parameter
  })
}

export function queryBackPerformanceForAmount (parameter = {}) {
  return axios({
    url: '/collectionTask/backPerformanceForAmount',
    method: 'post',
    data: parameter
  })
}


export function findCollectionModelList (parameter = {}) {
  return axios({
    url: '/statistics/findCollectionModelList',
    method: 'post',
    data: parameter
  })
}

export function queryReductionList (parameter = {}) {
  return axios({
    url: '/collectionLog/reductionList',
    method: 'post',
    data: parameter
  })
}

export function queryCollectionBlackCustList (parameter = {}) {
  return axios({
    url: '/collectionBlackCust/list',
    method: 'post',
    data: parameter
  })
}

export function queryCollectionBlackCustAdd (parameter = {}) {
  return axios({
    url: '/collectionBlackCust/add',
    method: 'post',
    data: parameter
  })
}

export function approvelReduction (parameter = {}) {
  return axios({
    url: '/collectionLog/approvelReduction',
    method: 'post',
    data: parameter
  })
}

export function colDataGroupRepaymentIntention (parameter = {}) {
  return axios({
    url: '/collectionTask/colDataGroupRepaymentIntention',
    method: 'post',
    data: parameter
  })
}

export function colDataGroupFollowResult (parameter = {}) {
  return axios({
    url: '/collectionTask/colDataGroupFollowResult',
    method: 'post',
    data: parameter
  })
}

export function colDataGroupRepaymentIntentionAndName (parameter = {}) {
  return axios({
    url: '/collectionTask/colDataGroupRepaymentIntentionAndName',
    method: 'post',
    data: parameter
  })
}

export function colDataGroupFollowResultAndName (parameter = {}) {
  return axios({
    url: '/collectionTask/colDataGroupFollowResultAndName',
    method: 'post',
    data: parameter
  })
}


export function colDataGroupRepaymentIntentionP (parameter = {}) {
  return axios({
    url: '/platform/collectionTask/colDataGroupRepaymentIntentionP',
    method: 'post',
    data: parameter
  })
}

export function colDataGroupFollowResultP (parameter = {}) {
  return axios({
    url: '/platform/collectionTask/colDataGroupFollowResultP',
    method: 'post',
    data: parameter
  })
}

export function colDataGroupRepaymentIntentionAndNameP (parameter = {}) {
  return axios({
    url: '/platform/collectionTask/colDataGroupRepaymentIntentionAndNameP',
    method: 'post',
    data: parameter
  })
}

export function colDataGroupFollowResultAndNameP (parameter = {}) {
  return axios({
    url: '/platform/collectionTask/colDataGroupFollowResultAndNameP',
    method: 'post',
    data: parameter
  })

}

export function queryZeroCollector (parameter = {}) {
  return axios({
    url: '/collectionTask/collection/GuoNaiZeroCollector',
    method: 'post',
    data: parameter
  })
}


export function queryGuoNaiZeroCollector (parameter = {}) {
  return axios({
    url: '/collectionTask/guoNaiZeroCollector',
    method: 'post',
    data: parameter
  })
}

export function getCollectionRank (parameter = {}) {
  return axios({
    url: '/collectionTask/collectionRank',
    method: 'post',
    data: parameter
  })
}

export function collectionCountByHour(parameter = {}) {
  return axios({
    url: '/collectionReplaceTask/collectionCountByHour',
    method: 'post',
    data: parameter
  })
}

export function orderCountByHour(parameter = {}) {
  return axios({
    url: '/collectionReplaceTask/orderCountByHour',
    method: 'post',
    data: parameter
  })
}

export function groupOrderByMonth(parameter = {}) {
  return axios({
    url: '/collectionReplaceTask/groupOrderByMonth',
    method: 'post',
    data: parameter
  })
}

export function groupOrderByDay(parameter = {}) {
  return axios({
    url: '/collectionReplaceTask/groupOrderByDay',
    method: 'post',
    data: parameter
  })
}

export function getListByParams(parameter = {}) {
  return axios({
    url: '/collectionLog/getListByParams',
    method: 'post',
    data: parameter
  })
}

export function collectionComplaints (parameter = {}) {
  return axios({
    url: '/collectionComplaint/list',
    method: 'post',
    data: parameter
  })
}


//催收员姓名

export function getCollectorName (parameter = {}) {
  return axios({
    url: '/collectionTask/selectUserNameList',
    method: 'post',
    data: parameter
  })
}

export function getCollectorMobile (parameter = {}) {
  return axios({
    url: '/collectionTask/selectUserMobileList',
    method: 'post',
    data: parameter
  })
}

export function getselectXsUserNameList (parameter = {}) {
  return axios({
    url: '/collectionTask/selectXsUserNameList',
    method: 'post',
    data: parameter
  })
}

export function getupdateSchedulingById (parameter = {}) {
  return axios({
    url: '/collectionTask/updateSchedulingById',
    method: 'post',
    data: parameter
  })
}

//催收话机人员账号表
export function getcollectionPhoneAccountLogList (parameter = {}) {
  console.log('parameter---->',parameter)
  return axios({
    url: '/collectionPhoneAccountLog/list',
    method: 'post',
    data: parameter
  })
}

export function updatecollectionPhoneAccountLogList (parameter = {}) {
  return axios({
    url: '/collectionPhoneAccountLog/update',
    method: 'post',
    data: parameter
  })
}
export function deletecollectionPhoneAccountLogList (parameter = {}) {
  return axios({
    url: '/collectionPhoneAccountLog/delete',
    method: 'post',
    data: parameter
  })
}
export function insertcollectionPhoneAccountLogList (parameter = {}) {
  return axios({
    url: '/collectionPhoneAccountLog/insert',
    method: 'post',
    data: parameter
  })
}


//call log 查询
export function getcalllogList (parameter = {}) {
  return axios({
    url: '/collectionPhoneAccountLog/queryCallList',
    method: 'post',
    data: parameter
  })
}

export function getCallNxForTel (parameter = {}) {
  return axios({
    url: '/call/getNxLog',
    method: 'post',
    data: parameter
  })
}

export function getPartRepatmentData (parameter = {}) {
  return axios({
    url: '/collectionTask/getPartRepatmentData',
    method: 'post',
    data: parameter
  })
}

export function queryCollectionSurveillanceInfo (parameter = {}) {
  return axios({
    url: '/collectionSurveillance/queryCollectionSurveillanceInfo',
    method: 'post',
    data: parameter
  })
}

export function querySurveillanceConfig (parameter = {}) {
  return axios({
    url: '/collectionSurveillance/querySurveillanceConfig',
    method: 'post',
    data: parameter
  })
}

export function saveSurveillanceConfig (parameter = {}) {
  return axios({
    url: '/collectionSurveillance/saveSurveillanceConfig',
    method: 'post',
    data: parameter
  })
}

export function lockAccount (parameter = {}) {
  return axios({
    url: '/collectionSurveillance/lockAccount',
    method: 'post',
    data: parameter
  })
}

export function queryColStatistics (parameter = {}) {
  return axios({
    url: '/collectionSurveillance/queryColStatistics',
    method: 'post',
    data: parameter
  })
}

export function queryColRelatedRank (parameter = {}) {
  return axios({
    url: '/collectionSurveillance/queryColRelatedRank',
    method: 'post',
    data: parameter
  })
}

export function queryUserCollectionDetail (parameter = {}) {
  return axios({
    url: '/collectionSurveillance/queryUserCollectionDetail',
    method: 'post',
    data: parameter
  })
}